import { Injectable } from '@angular/core';
import { featureTogglingConfig } from '@app/shared/constants/feature.config';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { BusinessOrderLoad } from 'app/shared/models/admin/business-order-load';
import { BusinessOrder } from 'app/shared/models/admin/businessOrder';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessOrderService {

  private static readonly endpoint = featureTogglingConfig.orders.pages['create-business-order'].concierge ? 'BusinessOrder' : 'BusinessOrderExpress';
  private static readonly endpointCustomer = 'Customers';
  private static readonly endpointMailItem = 'MailItem';
  private static readonly endpointPayment = 'Payments';

  constructor(private http: HttpClientService) { }

  get(id: number) {
    return this.http.get<any>(`${BusinessOrderService.endpoint}/GetById/${id}`, undefined, services.orderService);
  }

  listActive(body: any): Observable<BusinessOrder[]> {
    return this.http.post<BusinessOrder[]>(body, `${BusinessOrderService.endpoint}/GetAllActive`, undefined, services.orderService);
  }

  create(model: Object): Observable<BusinessOrder> {
    return this.http.postFormData(model, `${BusinessOrderService.endpoint}/Create`, undefined, services.orderService);

  }

  createBusinessOrderDraft(model: Object): Observable<BusinessOrder> {
    return this.http.postFormData(model, `${BusinessOrderService.endpoint}/CreateBusinessOrderDraft`, undefined, services.orderService);
  }

  getAllDraftBusinessOrder() {
    return this.http.get<BusinessOrderLoad[]>(`${BusinessOrderService.endpoint}/GetAllDraftBusinessOrder`, undefined, services.orderService)
  }

  ActiveInActiveLanguage(model: Object): Observable<BusinessOrder> {
    return this.http.post(model, `${BusinessOrderService.endpoint}/ActiveInActiveLanguage/`, undefined, services.orderService);
  }

  update(id, model: object): Observable<any> {
    return this.http.postFormData(model, `${BusinessOrderService.endpoint}/Update`, undefined, services.orderService);
  }

  delete(LanguageId: number) {
    return this.http.delete<boolean>(`${BusinessOrderService.endpoint}/Delete/${LanguageId}`, undefined, services.orderService);
  }

  GetOrderByCustomerId(customerId: number) {
    return this.http.get<BusinessOrder>(`${BusinessOrderService.endpoint}/GetOrderByCustomerId/${customerId}`, undefined, services.orderService);
  }

  GetAllCustomerNamesAsync(customerId: number) {
    return this.http.get(`${BusinessOrderService.endpointCustomer}/GetAllCustomerNamesAsync`)
  }

  getBusinessOrderCount() {
    return this.http.get(`${BusinessOrderService.endpoint}/GetBusinessOrderCount`, undefined, services.orderService);
  }

  getDailyOrders() {
    return this.http.get(`${BusinessOrderService.endpoint}/GetDailyOrders`, undefined, services.orderService);
  }

  getClosedOrders() {
    return this.http.get(`${BusinessOrderService.endpoint}/GetClosedOrders`, undefined, services.orderService);
  }

  getStatementPaginatedList(model: Object): Observable<{ result: any[], totalCount: number }> {
    return this.http.post<{ result: any[], totalCount: number }>(model, `${BusinessOrderService.endpoint}/GetStatementPaginatedList`, undefined, services.orderService);
  }

  receiveOrder(model: Object) {
    return this.http.post(model, `${BusinessOrderService.endpoint}/ReceiveOrder`, undefined, services.orderService);
  }

  createStatement(model: Object) {
    return this.http.post(model, `${BusinessOrderService.endpoint}/CreateStatement`, undefined, services.orderService);
  }

  updateStatement(model: Object) {
    return this.http.postFormData(model, `${BusinessOrderService.endpoint}/UpdateStatement`, undefined, services.orderService);
  }

  getReceiveOrderPaginatedList(model: Object): Observable<{ result: any[], totalCount: number }> {
    return this.http.post<{ result: any[], totalCount: number }>(model, `${BusinessOrderService.endpoint}/GetReceiveOrderPaginatedList`, undefined, services.orderService);
  }

  createInternalPostOrder(model: Object): Observable<BusinessOrder> {
    return this.http.post(model, `${BusinessOrderService.endpoint}/CreateInternal`, undefined, services.orderService);
  }

  editInternalPostOrder(model: Object): Observable<BusinessOrder> {
    return this.http.post(model, `${BusinessOrderService.endpoint}/UpdateInternalOrder`, undefined, services.orderService);
  }

  getInternalList(model: Object): Observable<BusinessOrder> {
    return this.http.post(model, `${BusinessOrderService.endpoint}/GetInternalList`, undefined, services.orderService);
  }

  getReceivedMailitemsPrint(model: Object): Observable<any> {
    return this.http.post(model, `${BusinessOrderService.endpointMailItem}/GeReceivedMailitemsPrint`, undefined, services.orderService);
  }

  printPostBagStatement(workOrderId: number): Observable<any> {
    return this.http.post({ workOrderId }, `${BusinessOrderService.endpoint}/PrintPostBagStatement`, undefined, services.orderService);
  }

  updateTrackingNumber(model: Object) {
    return this.http.post(model, `${BusinessOrderService.endpoint}/UpdateTrackingNumber`, undefined, services.orderService);
  }

  getPaymentData(referenceId: string) {
    return this.http.get<any>(`${BusinessOrderService.endpointPayment}/GetByRferenceId/${referenceId}`, undefined, services.orderService);
  }
  payAgain(id, model: object): Observable<any> {
    return this.http.post(model, `${BusinessOrderService.endpoint}/PayAgain`, undefined, services.orderService);
  }

  getInternationalOrderByIdForPrint(id: number) {
    return this.http.get<any>(`${BusinessOrderService.endpoint}/GetInternationalOrderByIdForPrint/${id}`, undefined, services.orderService);
  }

  getInternationalOrderByIdForPrintRecipet(id: number) {
    return this.http.get<any>(`${BusinessOrderService.endpoint}/GetInternationalOrderByIdForPrintRecipet/${id}`, undefined, services.orderService);
  }
}
